module.exports = __webpack_public_path__ + "img/hammer_w.bc2918cd.svg";